import { useMutation, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import client from '../../apollo-client';

import { replaceTripshepherdWithSeeSight } from '../../utils/trip-sheppered-text';
import { ATTRACTION_PAGE } from '../../api/attraction';
import Head from 'next/head';
import {
  FETCH_TOP_TIPS,
  INSERT_TOP_TIP,
  UPDATE_TOP_TIP
} from '../../api/abondonedCheckoutMutation';
import axios from 'axios';
import { ThingsToDo } from '../../components/ThingsToDo/ThingsToDo';
import { ThingsToDO } from '../../types/pages/things-to-do';
import { TopTip as TopTipType } from '../../components/Attraction/topTip';
import { LoadingSpinner } from '../../shared-components/LoadingSpinner/LoadingSpinner';
import { AttractionPage } from '../../components/Attraction/AttractionPage';
import { useAuthContext } from '../../utils/context/authContext';
interface TopTips {
  id: string;
  text: string;
  likes: number;
  dislikes: number;
}
export interface Review {
  name: string;
  traveller?: string;
  user_image?: string;
  rating: string;
  created_at: string;
  productId?: string;
  review: string;
  reviewId?: string;
  userId?: string;
  image?: string;
  gs_url?: string;
}
export interface Top {
  top_tips: TopTips[];
}
interface IProps {
  attraction: ATTRACTION | ThingsToDO;
  params: Record<string, any>;
  slug: string;
}
interface CARDMEDIAINTERFACE {
  name: string;
  alt: string;
  url: string;
  fragment: string;
  type: string;
}
interface PRODUCTINTERFACE {
  id: string;
  name: string;
  slug: string;
  duration: string;
  price: string;
  cardMessage: string;
  cardSnippet: string;
  cardMedia: [CARDMEDIAINTERFACE];
  reviews: [
    {
      id: string;
      rating: number;
    }
  ];
}
interface ATTRACTION_PAGE_INTERFACE {
  strapi_Attraction: [ATTRACTION];
}
export interface ATTRACTION {
  id: number;
  long_description: string;
  short_description: string;
  banner_media: Array<{ image: string }> | any;
  canonical: string;
  city: number;
  address: string;
  hours_of_operation: string;
  meta_description: string;
  meta_title: string;
  og_title: string;
  name: string;
  page_title: string;
  title: string;
  snippet: string;
  slug: string;
  google_data: GOOGLEDATA;
  tickets: boolean;
  og_description: string;
  attraction_availability: ATTRACTION_AVAILABILITY;
  images: [
    {
      file: {
        url: string;
        alternativeText: string;
      };
    }
  ];
}
interface GOOGLEDATA {
  rating: number;
  reviews: Review[];
  user_ratings_total: number;
  current_opening_hours: {
    open_now: boolean;
    weekday_text: string[];
  };
  wheelchair_accessible_entrance: boolean;
}
export interface ATTRACTION_AVAILABILITY {
  limit: number;
  type: ATTRACTION_AVAILABILITY_TYPE;
  prices: PRICES;
}
enum ATTRACTION_AVAILABILITY_TYPE {
  FREE_SALE = 'FREE_SALE',
  EXTERNAL_AVAILABILITY = 'EXTERNAL_AVAILABILITY'
}
interface PRICES {
  adults: number;
  children: number;
  infants: number;
}
export async function getServerSideProps({ params }: IProps) {
  try {
    const slug = `${params.slug}/${params.slug2}`;
    let data;

    if (params.slug2.startsWith('things-to-do-in')) {
      const cityName = params.slug2.split('things-to-do-in-')[1];
      // Check if cityName matches params.slug
      if (cityName && params.slug === cityName) {
        // Fetch things to do data using axios
        const response = await axios.get(
          `${process.env.NEXT_PUBLIC_FIREBASE_CONNECTION}/things-to-do/${params.slug2}?product=true&blog=true`
        );
        data = response.data;
      } else {
        // If cityName does not match params.slug, return a 404 page
        return {
          redirect: {
            statusCode: 301,
            destination: '/404'
          }
        };
      }
    } else {
      // Fetch attraction data from the Strapi API
      const {
        data: {
          strapi_Attraction: [attraction] = []
        } = {} as ATTRACTION_PAGE_INTERFACE
      } = await client.query<ATTRACTION_PAGE_INTERFACE>({
        query: ATTRACTION_PAGE,
        variables: {
          slug,
          slug2: slug
        }
      });

      data = attraction;
    }

    if (!data) {
      return {
        redirect: {
          statusCode: 301,
          destination: '/404'
        }
      };
    }

    return {
      props: {
        attraction: JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(data))
        ),
        slug
      }
    };
  } catch (error) {
    console.error('Error fetching data:', error);
    return {
      notFound: true
    };
  }
}

const SubSlug = ({ attraction, slug }: IProps) => {
  const [thingsToDoTopTips, setThingsToDoTopTips] = useState<TopTipType[]>([]);
  // const [thingsToDoData, setThingsToDoData] = useState<ThingsToDO>();
  // const [attractionData, setAttractionData] = useState<ATTRACTION>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user }: any = useAuthContext();
  const isAttractionsPage = !(slug as string).includes('things-to-do-in');

  // useEffect(() => {
  //   if (attraction) {
  //     if (!slug.includes('things-to-do-in')) {
  //       setAttractionData(attraction as ATTRACTION);
  //     } else {
  //       setThingsToDoData(attraction as ThingsToDO);
  //     }
  //   }
  // }, [attraction, slug]);

  const fetchThingsToDoTopTips = async () => {
    let url;
    if (user) {
      url = `${process.env.NEXT_PUBLIC_FIREBASE_CONNECTION}/top-tips/${
        slug.split('/')[1]
      }?limit=40&page=1&user=${user?.uid}`;
    } else {
      url = `${process.env.NEXT_PUBLIC_FIREBASE_CONNECTION}/top-tips/${
        slug.split('/')[1]
      }?limit=40&page=1`;
    }

    try {
      const response = await axios.get(url);
      setThingsToDoTopTips(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchThingsToDoTopTips();
  }, [user]);

  const { data, loading } = useQuery(FETCH_TOP_TIPS, {
    variables: { slug }
  });
  const [top, setTop] = useState<Top[]>([]);
  useEffect(() => {
    if (!loading && data) {
      setTop(data.strapi_Attraction);
    }
  }, [loading]);
  const updateTopTip = async (id: string, likes: number, dislikes: number) => {
    try {
      const {
        data: {
          update_strapi_top_tips: { returning }
        }
      } = await updateTopTipMutation({
        variables: {
          id: id,
          likes: likes,
          dislikes: dislikes
        }
      });

      const updatedTopTip = returning[0];
      setTop(prevTop => {
        const newTop = prevTop.map(top => {
          return {
            ...top,
            top_tips: top.top_tips.map(tip =>
              tip.id == updatedTopTip.id
                ? {
                    ...tip,
                    likes: updatedTopTip.likes,
                    dislikes: updatedTopTip.dislikes
                  }
                : tip
            )
          };
        });
        return newTop;
      });
    } catch (error) {
      console.error('Error updating top tip:', error);
    }
  };
  const [updateTopTipMutation] = useMutation(UPDATE_TOP_TIP);

  const [toptipText, setToptipText] = useState<string>('');
  const [insertTopTipMutation] = useMutation(INSERT_TOP_TIP);
  const handleSubmit = async () => {
    try {
      const {
        data: {
          insert_strapi_top_tips: { returning }
        }
      } = await insertTopTipMutation({
        variables: {
          text: toptipText,
          id: (attraction as ATTRACTION)?.id
        }
      });
      const updatedTopTip = returning[0];
      const newTopTip = {
        id: updatedTopTip.id,
        text: updatedTopTip.text,
        likes: 0,
        dislikes: 0
      };
      setTop(prevTop => {
        const updatedTop = {
          ...prevTop[0],
          top_tips: [newTopTip, ...prevTop[0].top_tips]
        };
        return [updatedTop, ...prevTop.slice(1)];
      });

      setIsModalOpen(false);
      setToptipText('');
    } catch (error) {
      console.error('Mutation error:', error);
    }
  };

  return (
    <>
      {isAttractionsPage ? (
        <>
          <Head>
            <meta
              name="og:title"
              content={`${replaceTripshepherdWithSeeSight(
                (attraction as ATTRACTION).page_title
              )}`}
            />
            <meta
              name="og:description"
              content={replaceTripshepherdWithSeeSight(
                attraction.meta_description
              )}
            />
            <title>
              {replaceTripshepherdWithSeeSight(
                (attraction as ATTRACTION).page_title
              )}{' '}
            </title>
            <meta
              name="description"
              content={replaceTripshepherdWithSeeSight(
                attraction.meta_description
              )}
              key="metadescription"
            />
            <link
              href={replaceTripshepherdWithSeeSight(attraction.canonical)}
              rel="canonical"
              key="canonical"
            />
            {(attraction as ATTRACTION).banner_media &&
              (attraction as ATTRACTION)?.banner_media !== null && (
                <meta
                  name="og:image"
                  content={
                    (attraction as ATTRACTION).banner_media[0] &&
                    (attraction as ATTRACTION).banner_media[0].image
                  }
                />
              )}
          </Head>
          {attraction ? (
            <AttractionPage
              attraction={attraction as ATTRACTION}
              handleSubmit={handleSubmit}
              setToptipText={setToptipText}
              updateTopTip={updateTopTip}
              isModalOpen={isModalOpen}
              top={top}
              setTop={setTop}
              setIsModalOpen={setIsModalOpen}
              toptipText={toptipText}
            />
          ) : (
            <div className="flex justify-center items-center h-[calc(100vh-140px)]">
              <LoadingSpinner className="w-8 h-8" />
            </div>
          )}
        </>
      ) : (
        <>
          <Head>
            <meta
              name="og:title"
              content={replaceTripshepherdWithSeeSight(attraction.og_title)}
            />
            <meta
              name="og:description"
              content={replaceTripshepherdWithSeeSight(
                attraction.og_description
              )}
            />
            <title>{replaceTripshepherdWithSeeSight(attraction.title)}</title>
            <meta
              name="description"
              content={replaceTripshepherdWithSeeSight(
                attraction.meta_description
              )}
              key="metadescription"
            />
            <link
              href={replaceTripshepherdWithSeeSight(attraction.canonical)}
              rel="canonical"
              key="canonical"
            />
            {(attraction as ThingsToDO).og_image && (
              <meta
                name="og:image"
                content={(attraction as ThingsToDO).og_image}
              />
            )}
          </Head>
          {attraction ? (
            <ThingsToDo
              thingsToDoDetails={attraction as ThingsToDO}
              topTips={thingsToDoTopTips}
            />
          ) : (
            <div className="flex justify-center items-center h-[calc(100vh-140px)]">
              <LoadingSpinner className="w-8 h-8" />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SubSlug;
